import { configureStore } from "@reduxjs/toolkit";
import menuSlice from "./slices/menuSlice";
import authSlice from "./slices/authSlice";
import userSlice from "./slices/userSlice";

export default configureStore({
  reducer: {
    menuReducer: menuSlice,
    authReducer: authSlice,
    userReducer: userSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
